import { Button } from '@ui/components/base/button';
import { Spinner } from '@ui/components/base/spinner';

interface LoaderButtonProps extends React.ComponentProps<typeof Button> {
  loading?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
}

const LoaderButton = ({ loading, disabled, children, ...rest }: LoaderButtonProps) => (
  <Button {...rest} disabled={disabled ?? loading}>
    {loading && <Spinner className="size-4" />}
    {children}
  </Button>
);

export { LoaderButton };
